import { VRAsset } from './asset.js';
import { Node } from '../../../third-party/webxr/render/core/node.js';
import { PrimitiveStream } from '../../../third-party/webxr/render/geometry/primitive-stream.js';

export class VROverlay extends VRAsset {
    static count = 0;
    static aM = [[0, 0, 1, 0, 0, 0, 0, 0], [0, 0, 1, 0, 0, 0, 0, 0], [0, 0, 1, 0, 0, 0, 0, 0], [0, 0, 1, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 1, 0, 0], [0, 0, 0, 0, 0, 1, 0, 0], [0, 0, 0, 0, 0, 1, 0, 0], [0, 0, 0, 0, 0, 1, 0, 0]];
    static bM = [0, 0, 0, 0, 0, 0, 0, 0];

    constructor (vr, scene, options) {
      super(vr, scene, options);

      this.count = VROverlay.count;
      if (!this.options.id) this.options.id = 'overlay_' + this.count;

      this.widthYaw = 10;
      this.heightPitch = 30;
      if (this.width === undefined) {
        this.width = 874;
      }
      if (this.height === undefined) {
        this.height = 3211;
      }

      if (!this.options.distance) this.options.distance = 4.0;

      if (!this.options.maxDistance) {
        this.options.maxDistance = 1.7;
      }

      if (!this.options.minDistance) {
        this.options.minDistance = 6;
      }

      this.setDistance(this.options.distance);
      this.useBackFacing = false;

      if (!this.transformOriginX) {
        this.transformOriginX = 0;
      }

      if (!this.transformOriginY) {
        this.transformOriginY = 0;
      }

      if (!this.topRightYawPitch) this.topRightYawPitch = {};
      if (!this.bottomRightYawPitch) this.bottomRightYawPitch = {};
      if (!this.bottomLeftYawPitch) this.bottomLeftYawPitch = {};

      this.div.addClass('ca-vr_overlay');
      this.div.addClass('ca-vr_overlay' + this.count);
      this.computedStyle = window.getComputedStyle(this.div[0]);
      VROverlay.count++;

      this.img = $('<img />');
      this.img.attr('draggable', false);
      // this.img.height(800);
      if (this.hasAction) this.img.css('cursor', 'zoom-in');
      this.img.on('load', function () {
        // alert('width: ' + this.naturalWidth + ' and height: ' + this.naturalHeight);
      });
      this.assetContainer.append(this.img);

      this.img.mouseup(function (event) {
        this.stopMoving();
      }.bind(this));

      if (this.options.allowMove) {
        this.div.mousedown(
          function () {
            if (this.vr.isEditing()) {
              this.vr.undoRedo.addToUndoStack({
                action: 'boardPlacement',
                data: this,
                x: this.options.yaw,
                y: this.options.pitch,
                distance: this.options.distance
              });
            }
          }.bind(this)
        );

        this.div.mouseup(
          function () {
            if (this.vr.isEditing()) {
              this.vr.undoRedo.addToRedoStack({
                action: 'boardPlacement',
                data: this,
                x: this.options.yaw,
                y: this.options.pitch,
                distance: this.options.distance
              });
            }
          }.bind(this)
        );
      }
      this.moveTo(this.options.yaw, this.options.pitch);
      // this.node = new VROverlayNode(this);
    }

    setImage (src) {
      this.img.attr('src', src);
    }

    saveMouseDownState (event) {
      super.saveMouseDownState(event);

      this.mouseDownDistance = this.options.distance;
      this.mouseDownTopLeftYawPitch = { yaw: this.topLeftYawPitch.yaw, pitch: this.topLeftYawPitch.pitch };
      this.mouseDownTopRightYawPitch = { yaw: this.topRightYawPitch.yaw, pitch: this.topRightYawPitch.pitch };
      this.mouseDownBottomRightYawPitch = { yaw: this.bottomRightYawPitch.yaw, pitch: this.bottomRightYawPitch.pitch };
      this.mouseDownBottomLeftYawPitch = { yaw: this.bottomLeftYawPitch.yaw, pitch: this.bottomLeftYawPitch.pitch };
    }

    mousemove (event) {
      if (!this.options.allowMove || !this.moving) return;
      this.moveBy((this.startX - event.clientX) / 10, (this.startY - event.clientY) / 10);
    }

    moveByInvoke (x, y, distance) {
      this.moving = true;
      this.setDistance(distance);
      super.moveBy(x, y);
      this.move(x, y);
      this.render();
      this.vr.enableMove(false);
      this.saveMouseDownState();
      this.moving = false;
      this.vr.enableMove(true);
    }

    moveBy (x, y) {
      super.moveBy(x, y);
      if (this.asset.fixedDistance === undefined) {
        this.setDistance(this.mouseDownDistance - (y / 10));
      } else {
        // might not even need to call this, but lets call it for now incase we start fucking it all up
        // this.setDistance(this.asset.distance);
        // this.options.maxDistance = this.asset.distance;
        // this.options.minDistance = this.asset.distance;
        this.options.maxDistance = 20;
        this.options.minDistance = 20;
        // maptable - need to pull from options
        this.setDistance(20);
      }
      this.move(this.mouseDownTopLeftYawPitch.yaw - x, this.options.pitch);
    }

    setDistance (distance) {
      this.options.distance = distance;
      this.options.distance = Math.max(this.options.distance, this.options.maxDistance);
      this.options.distance = Math.min(this.options.distance, this.options.minDistance);
      this.div.toggleClass('ca-vr_overlay_distmax', this.options.distance === this.options.minDistance);
    }

    render (t) {
      if (!super.render(t)) return;

      this.topRight = this.vr.yawPitchToPx(this.topRightYawPitch.yaw, this.topRightYawPitch.pitch);
      this.bottomRight = this.vr.yawPitchToPx(this.bottomRightYawPitch.yaw, this.bottomRightYawPitch.pitch);
      this.bottomLeft = this.vr.yawPitchToPx(this.bottomLeftYawPitch.yaw, this.bottomLeftYawPitch.pitch);
      if (this.topRight.x < 0 && this.bottomRight.x < 0) {
        this.setValidTransform(false);
        return false;
      }

      if (this.checkError() === 0) {
        this.updateTransform();
      }
    }

    getDistance () {
      return this.options.distance;
    }

    _getDeterminant (p0, p1, p2) {
      return p0.x * p1.y + p1.x * p2.y + p2.x * p0.y - p0.y * p1.x - p1.y * p2.x - p2.y * p0.x;
    }

    _hasDistancesError () {
      let lenX = this.topLeft.x - this.topRight.x;
      let lenY = this.topLeft.y - this.topRight.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;
      lenX = this.bottomLeft.x - this.bottomRight.x;
      lenY = this.bottomLeft.y - this.bottomRight.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;
      lenX = this.topLeft.x - this.bottomLeft.x;
      lenY = this.topLeft.y - this.bottomLeft.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;
      lenX = this.topRight.x - this.bottomRight.x;
      lenY = this.topRight.y - this.bottomRight.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;
      lenX = this.topLeft.x - this.bottomRight.x;
      lenY = this.topLeft.y - this.bottomRight.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;
      lenX = this.topRight.x - this.bottomLeft.x;
      lenY = this.topRight.y - this.bottomLeft.y;
      if (Math.sqrt(lenX * lenX + lenY * lenY) <= 1) return true;

      return false;
    }

    _hasPolyonError () {
      var det1 = this._getDeterminant(this.topLeft, this.topRight, this.bottomRight);
      var det2 = this._getDeterminant(this.bottomRight, this.bottomLeft, this.topLeft);
      if (this.useBackFacing) {
        if (det1 * det2 <= 0) return true;
      } else {
        if (det1 <= 0 || det2 <= 0) return true;
      }
      // eslint-disable-next-line no-redeclare
      var det1 = this._getDeterminant(this.topRight, this.bottomRight, this.bottomLeft);
      // eslint-disable-next-line no-redeclare
      var det2 = this._getDeterminant(this.bottomLeft, this.topLeft, this.topRight);
      if (this.useBackFacing) {
        if (det1 * det2 <= 0) return true;
      } else {
        if (det1 <= 0 || det2 <= 0) return true;
      }
      return false;
    }

    checkError () {
      if (this._hasDistancesError.apply(this)) {
        // Points are too close to each other.
        this.setValidTransform(false);
        return 1;
      } else if (this._hasPolyonError.apply(this)) {
        // Concave or backfacing if the useBackFacing property is false
        this.setValidTransform(false);
        return 2;
      }

      this.setValidTransform(true);
      return 0; // no error
    }

    getYaw () {
      const leftYaw = this.topLeftYawPitch.yaw;
      const rightYaw = this.topRightYawPitch.yaw;
      const yawWidth = rightYaw - leftYaw;

      return -leftYaw - (yawWidth / 2);
    }

    getPitch () {
      const topPitch = this.topLeftYawPitch.pitch;
      const bottomPitch = this.bottomLeftYawPitch.pitch;
      const pitchHeight = topPitch - bottomPitch;

      return -topPitch + (pitchHeight / 2);
    }

    setType (type) {
      this.options.type = type;
      this.div.addClass('ca-vr_overlay_' + type);
    }

    move (x, y) {
      super.move(x, y);
      this.topRightYawPitch.pitch = y;
      this.topRightYawPitch.yaw = x + this.widthYaw;
      this.bottomRightYawPitch.pitch = y - this.heightPitch;
      this.bottomRightYawPitch.yaw = x + this.widthYaw;
      this.bottomLeftYawPitch.pitch = y - this.heightPitch;
      this.bottomLeftYawPitch.yaw = x;
    }

    getType () {
      return this.options.type;
    }

    show () {
      this.div.removeClass('ca-vr_hotspot-hidden');
    };

    hide () {
      this.div.addClass('ca-vr_hotspot-hidden');
    };

    getTopRightYawPitch () {
      return this.topRightYawPitch;
    }

    getBottomRightYawPitch () {
      return this.bottomRightYawPitch;
    }

    getBottomLeftYawPitch () {
      return this.bottomLeftYawPitch;
    }

    getJsonConfig () {
      const config = Object.assign({}, this.options);
      return config;
    }

    updateTransform (forcedInitialDistance) {
      // check for undefineds
      if (this.topLeft === undefined) {
        this.topLeft = this.vr.yawPitchToPx(
          this.topLeftYawPitch.yaw,
          this.topLeftYawPitch.pitch
        );
      }

      if (this.topRight === undefined) {
        this.topRight = this.vr.yawPitchToPx(this.topRightYawPitch.yaw, this.topRightYawPitch.pitch);
      }

      if (this.bottomLeft === undefined) {
        this.bottomLeft = this.vr.yawPitchToPx(this.bottomLeftYawPitch.yaw, this.bottomLeftYawPitch.pitch);
      }

      if (this.bottomRight === undefined) {
        this.bottomRight = this.vr.yawPitchToPx(this.bottomRightYawPitch.yaw, this.bottomRightYawPitch.pitch);
      }

      const width = this.width;
      const height = this.height;

      //  magic here:
      const dst = [this.topLeft, this.topRight, this.bottomLeft, this.bottomRight];
      const arr = [0, 1, 2, 3, 4, 5, 6, 7];
      for (var i = 0; i < 4; i++) {
        VROverlay.aM[i][0] = VROverlay.aM[i + 4][3] = i & 1 ? width + this.transformOriginX : this.transformOriginX;
        VROverlay.aM[i][1] = VROverlay.aM[i + 4][4] = (i > 1 ? height + this.transformOriginY : this.transformOriginY);
        VROverlay.aM[i][6] = (i & 1 ? -this.transformOriginX - width : -this.transformOriginX) * (dst[i].x + this.transformOriginX);
        VROverlay.aM[i][7] = (i > 1 ? -this.transformOriginY - height : -this.transformOriginY) * (dst[i].x + this.transformOriginX);
        VROverlay.aM[i + 4][6] = (i & 1 ? -this.transformOriginX - width : -this.transformOriginX) * (dst[i].y + this.transformOriginY);
        VROverlay.aM[i + 4][7] = (i > 1 ? -this.transformOriginY - height : -this.transformOriginY) * (dst[i].y + this.transformOriginY);
        VROverlay.bM[i] = (dst[i].x + this.transformOriginX);
        VROverlay.bM[i + 4] = (dst[i].y + this.transformOriginY);
        VROverlay.aM[i][2] = VROverlay.aM[i + 4][5] = 1;
        VROverlay.aM[i][3] = VROverlay.aM[i][4] = VROverlay.aM[i][5] = VROverlay.aM[i + 4][0] = VROverlay.aM[i + 4][1] = VROverlay.aM[i + 4][2] = 0;
      }
      let kmax, sum;
      let row;
      const col = [];
      // eslint-disable-next-line no-redeclare
      var i, j, k, tmp;
      // eslint-disable-next-line no-redeclare
      for (var j = 0; j < 8; j++) {
        // eslint-disable-next-line no-redeclare
        for (var i = 0; i < 8; i++) col[i] = VROverlay.aM[i][j];
        for (i = 0; i < 8; i++) {
          row = VROverlay.aM[i];
          kmax = i < j ? i : j;
          sum = 0.0;
          // eslint-disable-next-line no-redeclare
          for (var k = 0; k < kmax; k++) sum += row[k] * col[k];
          row[j] = col[i] -= sum;
        }
        let p = j;
        for (i = j + 1; i < 8; i++) {
          if (Math.abs(col[i]) > Math.abs(col[p])) p = i;
        }
        if (p !== j) {
          for (k = 0; k < 8; k++) {
            tmp = VROverlay.aM[p][k];
            VROverlay.aM[p][k] = VROverlay.aM[j][k];
            VROverlay.aM[j][k] = tmp;
          }
          tmp = arr[p];
          arr[p] = arr[j];
          arr[j] = tmp;
        }
        if (VROverlay.aM[j][j] !== 0.0) for (i = j + 1; i < 8; i++) VROverlay.aM[i][j] /= VROverlay.aM[j][j];
      }
      for (i = 0; i < 8; i++) arr[i] = VROverlay.bM[arr[i]];
      for (k = 0; k < 8; k++) {
        for (i = k + 1; i < 8; i++) arr[i] -= arr[k] * VROverlay.aM[i][k];
      }
      for (k = 7; k > -1; k--) {
        arr[k] /= VROverlay.aM[k][k];
        for (i = 0; i < k; i++) arr[i] -= arr[k] * VROverlay.aM[i][k];
      }
      let style;
      if (forcedInitialDistance !== undefined && forcedInitialDistance !== null) {
        style = 'matrix3d(' + arr[0] + ',' + arr[3] + ', 0,' + arr[6] + ',' + arr[1] + ',' + arr[4] + ', 0,' + arr[7] + ',0, 0, 1, 0,' + arr[2] + ',' + arr[5] + ', 0, 1) scale(' + forcedInitialDistance + ')';
      } else if (this.options.propId === 'maptable') {
        style = 'matrix3d(' + arr[0] + ',' + arr[3] + ', 0,' + arr[6] + ',' + arr[1] + ',' + arr[4] + ', 0,' + arr[7] + ',0, 0, 1, 0,' + arr[2] + ',' + arr[5] + ', 0, 1) scale(20)';
      } else {
        style = 'matrix3d(' + arr[0] + ',' + arr[3] + ', 0,' + arr[6] + ',' + arr[1] + ',' + arr[4] + ', 0,' + arr[7] + ',0, 0, 1, 0,' + arr[2] + ',' + arr[5] + ', 0, 1) scale(' + this.options.distance + ')';
      }

      // eslint-disable-next-line no-return-assign
      return this.div[0].style.transform = style;
    }
}

// eslint-disable-next-line no-unused-vars
class VROverlayNode extends Node {
  constructor (overlay) {
    super();
  }

  onRendererChanged (renderer) {
    const stream = new PrimitiveStream();

    stream.startGeometry();

    // eslint-disable-next-line no-unused-vars
    const idx = stream.nextVertexIndex;
    // stream.pushTriangle(idx, idx+1, idx+2);
    // stream.pushTriangle(idx, idx+2, idx+3);

    stream.pushVertex(0, 0, 50, 0.6);

    stream.endGeometry();
  }
}
